var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolioManagementDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Portfolio Management Dashboard thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Clean capitalmind-style portfolio dashboard with returns table and equity curve chart.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pageBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eef2f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22c55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#10a35a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow",
    x: "-15%",
    y: "-15%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0f172a",
    floodOpacity: 0.16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 7,
    floodColor: "#0f172a",
    floodOpacity: 0.12
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "url(#pageBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 560,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 560,
    stroke: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 96,
    x2: 180,
    y2: 96,
    stroke: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 20,
    fill: "#0bbf72"
  }), /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 49,
    fill: "#ffffff",
    fontSize: 18,
    fontWeight: 900,
    textAnchor: "middle"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 39,
    fill: "#111827",
    fontSize: 21,
    fontWeight: 900
  }, "capitalmind"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 62,
    fill: "#059669",
    fontSize: 14
  }, "premium"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 132,
    fill: "#334155",
    fontSize: 17
  }, "Home"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154,
    width: 180,
    height: 48,
    fill: "#f2f4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154,
    width: 4,
    height: 48,
    fill: "#0bbf72"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 184,
    fill: "#0f172a",
    fontSize: 17,
    fontWeight: 700
  }, "Portfolios"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 234,
    fill: "#334155",
    fontSize: 17
  }, "Experimentals"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 284,
    fill: "#334155",
    fontSize: 17
  }, "Slack Archives"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 334,
    fill: "#334155",
    fontSize: 17
  }, "Refer a friend"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 384,
    fill: "#334155",
    fontSize: 17
  }, "Account"), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 500,
    x2: 180,
    y2: 500,
    stroke: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 530,
    r: 19,
    fill: "#0bbf72"
  }), /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 536,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900,
    textAnchor: "middle"
  }, "RN"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 525,
    fill: "#111827",
    fontSize: 14,
    fontWeight: 700
  }, "RN"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 544,
    fill: "#64748b",
    fontSize: 12
  }, "valid till Apr 19"), /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 75,
    fill: "#1f2937",
    fontSize: 35,
    fontWeight: 900
  }, "Portfolios"), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 112,
    width: 606,
    height: 132,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    filter: "url(#cardShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 150,
    fill: "#1f2937",
    fontSize: 20,
    fontWeight: 700
  }, "Trailing Returns"), /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 143,
    r: 19,
    fill: "#ffffff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 133v17m-6-6 6 6 6-6",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 170,
    width: 552,
    height: 30,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#64748b",
    fontSize: 13,
    fontWeight: 900
  }, /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 190
  }, "NAME"), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 190
  }, "YTD"), /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 190
  }, "1D"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 190
  }, "1W"), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 190
  }, "1M"), /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 190
  }, "3M"), /*#__PURE__*/React.createElement("text", {
    x: 704,
    y: 190
  }, "SI"), /*#__PURE__*/React.createElement("text", {
    x: 766,
    y: 190
  }, "DD")), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 202,
    x2: 812,
    y2: 202,
    stroke: "#d1d5db"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#111827",
    fontSize: 17
  }, /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 228
  }, "Focused"), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 228
  }, "14.4%"), /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 228
  }, "0.9%"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 228
  }, "2.2%"), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 228
  }, "8.1%"), /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 228
  }, "11.7%"), /*#__PURE__*/React.createElement("text", {
    x: 704,
    y: 228
  }, "17.4%"), /*#__PURE__*/React.createElement("text", {
    x: 766,
    y: 228
  }, "-0.3%")), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 236,
    x2: 812,
    y2: 236,
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 274,
    width: 606,
    height: 236,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    filter: "url(#cardShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 313,
    fill: "#111827",
    fontSize: 20,
    fontWeight: 900
  }, "Equity curve"), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 340,
    fill: "#64748b",
    fontSize: 14
  }, "Live since 2023-12-18  \u2022  As of 2024-04-23"), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 300,
    width: 82,
    height: 30,
    rx: 15,
    fill: "#f3f4f6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 574,
    y: 320,
    fill: "#111827",
    fontSize: 12
  }, "Reset range"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 291,
    fill: "#475569",
    fontSize: 12,
    fontWeight: 700
  }, "FROM DATE"), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 302,
    width: 82,
    height: 38,
    rx: 7,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    filter: "url(#softShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 681,
    y: 325,
    fill: "#1f2937",
    fontSize: 12
  }, "18-12-2023"), /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 291,
    fill: "#475569",
    fontSize: 12,
    fontWeight: 700
  }, "TO DATE"), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 302,
    width: 62,
    height: 38,
    rx: 7,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    filter: "url(#softShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 325,
    fill: "#1f2937",
    fontSize: 12
  }, "23-04")), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 365,
    width: 502,
    height: 122,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#e8edf2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 292,
    y1: 486,
    x2: 794,
    y2: 486
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292,
    y1: 445,
    x2: 794,
    y2: 445
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292,
    y1: 404,
    x2: 794,
    y2: 404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292,
    y1: 365,
    x2: 794,
    y2: 365
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#94a3b8",
    fontSize: 13
  }, /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 490
  }, "100"), /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 449
  }, "105"), /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 408
  }, "110"), /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 369
  }, "115")), /*#__PURE__*/React.createElement("path", {
    d: "M292 484 C315 468 342 476 362 456 C378 440 398 449 414 428 C432 405 454 398 474 392 C492 387 505 354 526 395 C543 430 560 386 582 382 C602 378 623 416 641 374 C660 334 681 386 701 410 C724 438 742 395 760 374 C775 357 783 366 794 352",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 490 C316 479 342 476 366 464 C386 454 406 468 424 446 C449 416 472 418 494 408 C514 399 532 428 552 410 C574 390 600 397 620 408 C644 421 662 434 684 416 C711 394 742 414 762 399 C780 386 787 389 794 381",
    fill: "none",
    stroke: "#16a34a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626,
    y: 456,
    width: 150,
    height: 34,
    rx: 17,
    fill: "#ecfdf5",
    stroke: "#bbf7d0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 473,
    r: 8,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 478,
    fill: "#166534",
    fontSize: 13,
    fontWeight: 900
  }, "Equity growth"), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 126,
    width: 90,
    height: 22,
    rx: 11,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 142,
    fill: "#15803d",
    fontSize: 12,
    fontWeight: 900
  }, "+14.4% YTD"), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 126,
    width: 94,
    height: 22,
    rx: 11,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 142,
    fill: "#1d4ed8",
    fontSize: 12,
    fontWeight: 900
  }, "17.4% SI"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioManagementDashboard);
export default __webpack_public_path__ + "static/media/portfolio-management-dashboard.e28511c61947eba01d5227acdc33c17d.svg";
export { ForwardRef as ReactComponent };